import { createSlice } from '@reduxjs/toolkit'

export const operationTypesSlice = createSlice({
  name: 'operationTypes',
  initialState: [],
  reducers: {},
})

const { actions, reducer } = operationTypesSlice
export const operationTypesActions = actions
export const operationTypesReducer = reducer
